module.exports = __webpack_public_path__ + "img/Gutenberg_logo_Poziom_RGB.b977ea60.png";